import { ActionTree } from 'vuex';
import axios from 'axios';
import { IdealProfileState, IdealProfile, RootState } from './ideal-profile-types';

export const actions: ActionTree<IdealProfileState, RootState> = {
  async getIdealProfile(context, payload): Promise<any> {
    await axios({ url: `https://vb0bti0a28.execute-api.ap-south-1.amazonaws.com/poc/mdm-svc/get-ideal-profile?functionId=${payload.functionSkillId}&role=${payload.roleSkillId}` }).then(
      (response) => {
        const payloadData: IdealProfile = response && response.data;
        context.commit('setIdealProfileInState', payloadData);
      },
      (error) => {
        console.log(error);
        context.commit('profileError');
      },
    );
  },
};
